import * as moment from 'moment';
import { IQueryString } from '../../../shared/models';

export class ClockDateFilter implements IQueryString {
    date: string;

    constructor(value: moment.Moment | string) {
        if (typeof value !== 'string') {
            this.date = value.format('MM/DD/YYYY');
            return;
        }
        this.date = value;
    }

    toQueryString() {
        return `date=${this.date}`;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/clock-in-out/shared/models/clock-date-filter.ts